import { rand } from "./random";

export const names = [
	'a.zimnitski',
	'Alena Alekhno',
	'Ales Pazniak',
	'Alexander Eskin',
	'Alexander Suslikov',
	'Alexandra Gavrilova',
	'Alexei Dulub',
	'Alexey Chopik',
	'Alex Zhakov',
	'Alina Lozyuk',
	'Anastasia Gotovchits',
	'Anastasia Rudenko',
	'Anastasiya Dorogokupets',
	'Andrei Astrouski',
	'Andrei Skachkou',
	'Andrew Suvalov',
	'Andrey Chembrovich',
	'Andrey Fedorovich',
	'Andrey Grod',
	'Andrey Kosobutskiy',
	'Andrey Romanyuk',
	'Anna Rak',
	'Anton Boltach',
	'Anton Shkinder',
	'Anzhy Cherniavsky',
	'Artemy Markovsky',
	'Artsiom Dziaryba',
	'Daria Korsik',
	'Daria Pechkovskaya,',
	'Darya Korsak',
	'Darya Pulyak',
	'Darya Shimanchik',
	'Dmitriy Bushuev',
	'Dmitry Bulka',
	'Dmitry Karpushkin',
	'Dmitry Kostenko',
	'Dmitry Parchinsky',
	'Dmitry Siziakin',
	'Dmitry Volynets',
	'Eduard Topchyan',
	'Egor Nickolayenya',
	'Elena Mastitskaya',
	'Eugene Bogdanov',
	'Eugene Pavlovets',
	'Eugene Vasilyev',
	'Eugenia Didenko',
	'i.klimko',
	'i.sharipova',
	'Igor Dulub',
	'Ilya Biyumen',
	'Irina Klimovich',
	'Ivan Makarevich',
	'Izabel Shchetsko',
	'Kirill Babiak',
	'Kirill Plyshevsky',
	'Kirill Volkov',
	'Ladutko Sergey',
	'Maksim Mikhno',
	'Maxim Brishten',
	'Maxim Ignatow',
	'Maxim Perenesenko',
	'Mikhail Shautsou',
	'Nikita Fedorenko',
	'Nikita Latkovich',
	'Nikita Pevnev',
	'Nikolai Borsuk',
	'Olga Ermolovich',
	'Olga Yankina',
	'Pavel Tsikhanavets',
	'Petr Gorban',
	'Rodion Tereshkov',
	'Sergey Furs',
	'Sergey Kilochytsky',
	'Sergey Krupenich',
	'Siarhei Siniak',
	'Timur Abubakarov',
	'Vadim Voloshanov',
	'Vera Yakovleva',
	'Victoria Lisowskaya',
	'Viktor Pulyak',
	'Viktoryia Vorsa',
	'Vitaly Krasutsky',
	'Vladimir Lebedevich',
	'Vladimir Sharaev',
	'Vlad Voropaev',
	'Yaroslav Sidoruk',
	'Yulia Gushchina',
];

export function getRandomName() { return names[rand(names.length)]; }
